



import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

import Dialog from '@/store/modules/dialog';
import store from '@/store/store';
import { getModule } from 'vuex-module-decorators';
import { User } from 'firebase';
const dialogModule = getModule(Dialog, store);

@Component
export default class UserName extends Vue {
  @Prop(Object) user: User

  showDialog() {
    dialogModule.openProfileDialog({ uid: this.user.uid, open: true })
  }

}
